import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import TreatmentsPage from './pages/TreatmentsPage';
import ContactPage from './pages/ContactPage';
import BookAppointmentPage from './pages/BookAppointmentPage';
import TestimonialsPage from './pages/TestimonialsPage';
import GalleryPage from './pages/GalleryPage';
import ArthroscopyPage from './components/Arthroscopy';
import SportsInjuriesPage from './components/SportsInjury';
import ShoulderKneeHipPage from './components/ShoulderKnee';
import FracturesTraumaPage from './components/FracturesTrauma';
import JointReplacementPage from './components/JointReplacement';
import PhysiotherapyRehabPage from './components/Physiotherapy';
import MedicalCampsPage from './components/MedicalCamps';
import FootAnklePage from './components/FootandAnkel';
import HandWristPage from './components/HandandWrist';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/treatments" element={<TreatmentsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book-appointment" element={<BookAppointmentPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/treatments/arthroscopy" element={<ArthroscopyPage />} />
          <Route path="/treatments/sports-injuries" element={<SportsInjuriesPage />} />
          <Route path="/treatments/shoulder-knee-hip" element={<ShoulderKneeHipPage />} />
          <Route path="/treatments/fractures-trauma" element={<FracturesTraumaPage />} />
          <Route path="/treatments/joint-replacement" element={<JointReplacementPage />} />
          <Route path="/treatments/physiotherapy-rehab" element={<PhysiotherapyRehabPage />} />
          <Route path="/treatments/medical-camps" element={<MedicalCampsPage />} />
          <Route path="/treatments/foot-ankle" element={<FootAnklePage />} />
          <Route path="/treatments/hand-wrist" element={<HandWristPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;